module.exports = __webpack_public_path__ + "static/media/image-3.429231a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-54/image-3.jpg
// module id = 272
// module chunks = 0